// ══════════════════════════════════════════════════════════════
// WHO LMS (Lambda-Mu-Sigma) Reference Tables
// Source: WHO Child Growth Standards (2006)
// Format: [ageMonths, L, M, S]
// ══════════════════════════════════════════════════════════════

export const LMS_TABLES = {
  boys: {
    weight: [
      [0, -0.3521, 3.3464, 0.14602],
      [1, -0.3521, 4.4709, 0.13395],
      [2, -0.3521, 5.5675, 0.12385],
      [3, -0.3521, 6.3762, 0.11727],
      [6, -0.3521, 7.9340, 0.11080],
      [9, -0.3521, 9.1525, 0.10698],
      [12, -0.3521, 10.2087, 0.10390],
      [18, -0.3521, 11.5014, 0.10170],
      [24, -0.3521, 12.6558, 0.10220],
      [36, -0.3521, 14.3450, 0.10695],
      [48, -0.3521, 16.1750, 0.11400],
      [60, -0.3521, 18.3414, 0.12200],
    ],
    height: [
      [0, 1, 49.8842, 0.03795],
      [1, 1, 54.7244, 0.03557],
      [2, 1, 58.4249, 0.03424],
      [3, 1, 61.4292, 0.03328],
      [6, 1, 67.6236, 0.03174],
      [9, 1, 72.0036, 0.03117],
      [12, 1, 75.7488, 0.03063],
      [18, 1, 82.3080, 0.03001],
      [24, 1, 87.8161, 0.03013],
      [36, 1, 96.1004, 0.03054],
      [48, 1, 103.3120, 0.03097],
      [60, 1, 110.0352, 0.03167],
    ],
  },
  girls: {
    weight: [
      [0, -0.3833, 3.2322, 0.14171],
      [1, -0.3833, 4.1873, 0.13724],
      [2, -0.3833, 5.1282, 0.13000],
      [3, -0.3833, 5.8458, 0.12619],
      [6, -0.3833, 7.2973, 0.12034],
      [9, -0.3833, 8.3817, 0.11683],
      [12, -0.3833, 9.5249, 0.11333],
      [18, -0.3833, 10.8200, 0.11108],
      [24, -0.3833, 12.1416, 0.11298],
      [36, -0.3833, 14.3278, 0.11939],
      [48, -0.3833, 16.4436, 0.12849],
      [60, -0.3833, 18.3953, 0.13468],
    ],
    height: [
      [0, 1, 49.1477, 0.03790],
      [1, 1, 53.6872, 0.03625],
      [2, 1, 57.0673, 0.03546],
      [3, 1, 59.8029, 0.03481],
      [6, 1, 65.7302, 0.03368],
      [9, 1, 70.1434, 0.03275],
      [12, 1, 74.0150, 0.03231],
      [18, 1, 80.7886, 0.03142],
      [24, 1, 86.4035, 0.03118],
      [36, 1, 95.1254, 0.03074],
      [48, 1, 102.7124, 0.03054],
      [60, 1, 109.4170, 0.03051],
    ],
  },
};
